"use strict";exports.isFuture=function(e){var t=new Date(e),r=new Date;return t.getTime()>r.getTime()};
//# sourceMappingURL=isFuture.cjs.map
